export default __webpack_public_path__ + "static/media/school-compass.2c653610.svg";